import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiMail, FiPhone, FiMapPin, FiLinkedin, FiTwitter, FiFacebook } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <SafeIcon icon={FiShield} className="h-8 w-8 text-blue-400" />
              <span className="text-2xl font-bold">YourPurviewPartner</span>
            </Link>
            <p className="text-gray-300 mb-6 max-w-md">
              Your trusted Microsoft Purview experts. We help organizations achieve data governance excellence and regulatory compliance through proven methodologies and expert implementation.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <SafeIcon icon={FiLinkedin} className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <SafeIcon icon={FiTwitter} className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <SafeIcon icon={FiFacebook} className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/data-governance" className="text-gray-300 hover:text-white transition-colors">Data Governance</Link></li>
              <li><Link to="/compliance-management" className="text-gray-300 hover:text-white transition-colors">Compliance Management</Link></li>
              <li><Link to="/data-loss-prevention" className="text-gray-300 hover:text-white transition-colors">Data Loss Prevention</Link></li>
              <li><Link to="/information-protection" className="text-gray-300 hover:text-white transition-colors">Information Protection</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors">All Services</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/case-studies" className="text-gray-300 hover:text-white transition-colors">Case Studies</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/purview-audit" className="text-gray-300 hover:text-white transition-colors">Purview Audit</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        {/* Contact Info & Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="flex items-center space-x-3">
              <SafeIcon icon={FiPhone} className="h-5 w-5 text-blue-400" />
              <span className="text-gray-300">(404) 480-3547</span>
            </div>
            <div className="flex items-center space-x-3">
              <SafeIcon icon={FiMail} className="h-5 w-5 text-blue-400" />
              <span className="text-gray-300">info@yourpurviewpartner.com</span>
            </div>
            <div className="flex items-start space-x-3">
              <SafeIcon icon={FiMapPin} className="h-5 w-5 text-blue-400 mt-1" />
              <span className="text-gray-300">755 Commerce Dr<br />Decatur, GA 30030</span>
            </div>
          </div>

          <div className="text-center">
            <p className="text-gray-400">
              © 2025-2026 YourPurviewPartner. All rights reserved. | <Link to="/privacy" className="hover:text-white ml-2">Privacy Policy</Link> | <Link to="/terms" className="hover:text-white ml-2">Terms of Service</Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;